import {
  CACHE_TAG_CONFIGURED_SERVICE_EVENT_LIST,
  CACHE_TAG_WORK_ORDER_DETAILS,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_WO_SECTION,
  CACHE_TAG_WORK_ORDER_VERSION_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_EVENT_VERSION_LIST,
} from 'api/cacheTagTypes'
import { withIdTag } from 'utils/cache'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    updateWorkOrder: builder.mutation({
      query: body => ({ url: '/api/v1/core/work-orders', method: 'PUT', body }),
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_CONFIGURED_SERVICE_EVENT_LIST,
        CACHE_TAG_WORK_ORDER_DETAILS,
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_WO_SECTION,
        CACHE_TAG_CONFIGURED_SERVICE_EVENT_VERSION_LIST,
        ...withIdTag(CACHE_TAG_WORK_ORDER_VERSION_LIST, arg?.id),
      ],
    }),
  }),
})

export const { useUpdateWorkOrderMutation } = extendedApi
